import axiosRequest from "@/utils/axiosRequest";

export function addUser(data) {
  return axiosRequest({
    url: `/admin/addUser`,
    data,
    method: "post"
  });
}

export function updateUser(data) {
  return axiosRequest({
    url: `/admin/updateUser`,
    data,
    method: "post"
  });
}

export function deleteUser(data) {
  return axiosRequest({
    url: `/admin/deleteUser`,
    data,
    method: "post"
  });
}

export function listUser(data) {
  return axiosRequest({
    url: `/admin/listUser`,
    data,
    method: "post"
  });
}

export function userDetail(data) {
  return axiosRequest({
    url: `/admin/userDetail`,
    data,
    method: "post"
  });
}

export function listGroup(data) {
  return axiosRequest({
    url: `/admin/listGroup`,
    data,
    method: "post"
  });
}

export function addGroup(data) {
  return axiosRequest({
    url: `/admin/addGroup`,
    data,
    method: "post"
  });
}

export function removeGroup(data) {
  return axiosRequest({
    url: `/admin/removeGroup`,
    data,
    method: "post"
  });
}

